import { useContext, useState } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { Spinner } from "../../../components";
import AuthContext from "../../../context/AuthContext";
import { ToolsRunAdmin } from "./ToolsRunAdmin";
import { ToolsRunClient } from "./ToolsRunClient";
import { PumpTrackerAdmin } from "./PumpTrackerAdmin";
import { PumpTrackerClient } from "./PumpTrackerClient";

type Section = "tools" | "pump";

export const ToolsRunPage = () => {
  const { idRole, isLoading } = useContext(AuthContext);
  const [section, setSection] = useState<Section>("tools");
  if (isLoading) return <Spinner />;

  return (
    <Box sx={{ mt: "-80px", minHeight: "100vh", bgcolor: "#F3F3F0" }}>
      <Box
        sx={{ bgcolor: "#fff", borderBottom: "1px solid #E7E7E3", px: "26px" }}
      >
        <Tabs
          value={section}
          onChange={(_, value: Section) => setSection(value)}
          sx={{
            minHeight: 44,
            "& .MuiTab-root": { minHeight: 44, fontSize: 12, fontWeight: 850 },
            "& .MuiTabs-indicator": { bgcolor: "#ED8B00", height: 3 },
          }}
        >
          <Tab value="tools" label="Tools Tracker" />
          <Tab value="pump" label="Tracker New Pumps" />
        </Tabs>
      </Box>
      {section === "tools" ? (
        idRole === 3 ? (
          <ToolsRunClient />
        ) : (
          <ToolsRunAdmin />
        )
      ) : idRole === 3 ? (
        <PumpTrackerClient />
      ) : (
        <PumpTrackerAdmin />
      )}
    </Box>
  );
};
